module.exports = __webpack_public_path__ + "media/images/green_tick-d248f1a923314c63daa362b58cc5794b.svg";